import React, {useEffect} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

import css from './OrdersOrdersMenuDatesComponent.module.css';
import {ordersActions} from "../../../store/slices/orders-slices";
import {paginationActions} from "../../../store/slices/pagination-slices";


const OrdersOrdersMenuDatesComponent = () => {
    const dispatch = useDispatch();
    const {register, watch} = useForm();

    const {filterParams} = useSelector(store => store.orders);

    const validFrom = watch("validFrom");
    const validTo = watch("validTo");

    useEffect(() => {
        // Reset pagination to page 1 when date filters change
        dispatch(paginationActions.changePage(1));
        
        dispatch(ordersActions.setFilterParams({
            startDate: validFrom || '',
            endDate: validTo || ''
        }));

        dispatch(ordersActions.getAllOrders({
            page: 1, // Always start from page 1 for new filters
            ...filterParams,
            startDate: validFrom || '',
            endDate: validTo || ''
        }));
    }, [validFrom, validTo, dispatch]);


    return (
        <div className={css.wrap}>
            <form className={css.blockForm}>
                <input type="date" id="validFrom" {...register("validFrom")}/>

                <input type="date" id="validTo" {...register("validTo")}/>
            </form>
        </div>
    );
};

export {OrdersOrdersMenuDatesComponent};

